/** Shared navigation context for citation intelligence; query parameters never authorize access. */
const SCOPE_KEYS = [
  'range',
  'start_date',
  'end_date',
  'week',
  'job_id',
  'job_ids',
  'period_grain',
  'period_key',
  'engine',
  'topic',
  'prompt_group',
  'prompt_group_id',
  'prompt_group_origin',
  'prompt_subtopic_id',
  'topic_filter',
  'prompt_ids',
  'prompt_id',
  'domain',
  'root_domain',
] as const;

type SearchParams = { get(key: string): string | null };

export function normalizeCitationPublisherDomain(domain: string) {
  return domain
    .trim()
    .toLowerCase()
    .replace(/^www\./, '');
}

export function citationScopeParams(source?: SearchParams | null) {
  const result = new URLSearchParams();
  for (const key of SCOPE_KEYS) {
    const value = source?.get(key);
    if (value) result.set(key, value);
  }
  if (result.has('topic_filter')) result.delete('prompt_ids');
  const domain = normalizeCitationPublisherDomain(
    result.get('domain') || result.get('root_domain') || ''
  );
  for (const key of ['domain', 'root_domain']) {
    if (domain) result.set(key, domain);
    else result.delete(key);
  }
  return result;
}

export function citationScopeHref(
  path: string,
  source?: SearchParams | null,
  overrides: Record<string, string | null | undefined> = {}
) {
  const params = citationScopeParams(source);
  for (const [key, value] of Object.entries(overrides)) {
    if (value) params.set(key, value);
    else params.delete(key);
  }
  if (params.has('topic_filter')) params.delete('prompt_ids');
  if ('domain' in overrides || 'root_domain' in overrides) {
    const domain = normalizeCitationPublisherDomain(
      overrides.domain ?? overrides.root_domain ?? ''
    );
    for (const key of ['domain', 'root_domain']) {
      if (domain) params.set(key, domain);
      else params.delete(key);
    }
  }
  if (path !== '/app/topics') params.delete('topic');
  const query = params.toString();
  return query ? `${path}?${query}` : path;
}
